import { mergeContent, getContent } from "@js/helpers/state.js";
import { CE_MAKE_MULTIPART } from "@js/actions/studio/campaign_content_section/multi_part_contents.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MAKE_MULTIPART:
      let prevStateContent = getContent(state, action.client_content_id);
      return mergeContent(state, action.client_content_id, {
        format: "both",
        active_html_editor:
          prevStateContent.format === "text"
            ? "bee"
            : prevStateContent.active_html_editor,
      });
    default:
      return state;
  }
};
